import { render, staticRenderFns } from "./fulfillment-detail-notes.vue?vue&type=template&id=20e5ee20"
import script from "./fulfillment-detail-notes.vue?vue&type=script&lang=js"
export * from "./fulfillment-detail-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports